import React from 'react'
import { Link } from 'react-router-dom'

const Signup = () => {
    return (
        <div className="flex justify-center">
            {/* <!-- start: page body area --> */}
            <div className="md:w-full p-7 bg-white border rounded auth-body">
                <form>
                    <ul className="grid gap-6 list-none li_animate">
                        <li className="col-span-6">
                            <label htmlFor='fullname' className="block text-base font-medium text-gray-700 mb-2">Full name</label>
                            <input type="text" id='fullname' className="bg-light rounded-lg py-4 px-3 border-transparent focus:border-primary w-full focus:outline-[0.5px] focus:outline-dashed focus:outline-offset-2 focus:outline-gray-600 focus:ring-0" placeholder="Jony" />
                        </li>
                        <li className="col-span-6">
                            <label htmlFor='space' className="block text-base font-medium text-gray-700 mb-2">&nbsp;</label>
                            <input type="text" id='space' className="bg-light rounded-lg py-4 px-3 border-transparent focus:border-primary w-full focus:outline-[0.5px] focus:outline-dashed focus:outline-offset-2 focus:outline-gray-600 focus:ring-0" placeholder="Parker" />
                        </li>
                        <li className="col-span-12">
                            <label htmlFor='emailaddress' className="block text-base font-medium text-gray-700 mb-2">Email address</label>
                            <input type="email" id='emailaddress' className="bg-light rounded-lg py-4 px-3 border-transparent focus:border-primary w-full focus:outline-[0.5px] focus:outline-dashed focus:outline-offset-2 focus:outline-gray-600 focus:ring-0" placeholder="name@gmail.com" />
                        </li>
                        <li className="sm:col-span-6 col-span-12">
                            <label htmlFor='password' className="block text-base font-medium text-gray-700 mb-2">Password</label>
                            <input type="password" id='password' className="bg-light rounded-lg py-4 px-3 border-transparent focus:border-primary w-full focus:outline-[0.5px] focus:outline-dashed focus:outline-offset-2 focus:outline-gray-600 focus:ring-0" placeholder="8+ characters required" />
                        </li>
                        <li className="sm:col-span-6 col-span-12">
                            <label htmlFor='finalPassword' className="block text-base font-medium text-gray-700 mb-2">Confirm password</label>
                            <input type="password" id='finalPassword' className="bg-light rounded-lg py-4 px-3 border-transparent focus:border-primary w-full focus:outline-[0.5px] focus:outline-dashed focus:outline-offset-2 focus:outline-gray-600 focus:ring-0" placeholder="8+ characters required" />
                        </li>
                        <li className="col-span-12">
                            <div className="flex items-center">
                                <input className="h-4 w-4" type="checkbox" id="TermsConditions" />
                                <label className="ml-2 block text-base " htmlFor="TermsConditions">
                                    I accept the
                                    <Link to="/" className="text-primary-900"> Terms and Conditions</Link>
                                </label>
                            </div>
                        </li>
                        <li className="col-span-12 mt-4 mb-2">
                            <Link className="block w-full py-2 bg-primary-800 hover:bg-primary-900 text-white text-center rounded-lg uppercase 
                             transition" to="/">Sign Up</Link>
                        </li>
                        <li className="col-span-12 text-center">
                            <span className="text-gray-500">
                                Already have an account?
                                <Link className="ml-2 text-primary-900" to="/signin">Sign in here</Link>
                            </span>
                        </li>
                    </ul>
                </form>
            </div>
        </div>

    )
}

export default Signup